import { render, staticRenderFns } from "./displayDetail.vue?vue&type=template&id=196f438a&scoped=true&"
import script from "./displayDetail.vue?vue&type=script&lang=js&"
export * from "./displayDetail.vue?vue&type=script&lang=js&"
import style0 from "./displayDetail.vue?vue&type=style&index=0&id=196f438a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196f438a",
  null
  
)

export default component.exports